// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { infoProps } from "@store/Themes/common/props/info";
import React, { FC, useContext } from "react";

export interface OrderEstimatedDeliveryDateStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderEstimatedDeliveryDate?: TypographyProps;
}

export const orderEstimatedDeliveryDateStyles: OrderEstimatedDeliveryDateStyles = {
    titleText: infoProps.label,
    orderEstimatedDeliveryDate: infoProps.value,
};

const styles = orderEstimatedDeliveryDateStyles;

const OrderEstimatedDeliveryDate: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties?.orderEstimatedDeliveryDate) {
        return null;
    }

    const estimatedDeliveryDate = new Date(order.properties.orderEstimatedDeliveryDate);

    if (Number.isNaN(estimatedDeliveryDate.getTime())) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="OrderEstimatedDeliveryDate">
                {translate("Estimated Delivery Date")}
            </Typography>
            <Typography
                {...styles.orderEstimatedDeliveryDate}
                aria-labelledby="OrderEstimatedDeliveryDate"
                data-test-selector="OrderEstimatedDeliveryDate"
            >
                <LocalizedDateTime
                    dateTime={estimatedDeliveryDate}
                    options={{ year: "numeric", month: "numeric", day: "numeric" }}
                />
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderEstimatedDeliveryDate,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
